import { enqueueSnackbar } from "notistack";
import { JService } from "../../api-service/ApiService";
import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import classes from "./DeleteTemplateModal.module.css";
import { useNavigate } from "react-router-dom";

const DeleteTemplateModal = ({
  visible,
  closeModalHandler,
  name,
  id,
  refreshTemplates = () => null,
}) => {
  const navigate = useNavigate();

  const deleteTemplateHandler = () => {
    JService.delete(`/api/v1/whatsapp/templates/?template_id=${id}`)
      .then((res) => {
        if (!res?.success)
          throw new Error(res?.message || "Could not delete template");
        enqueueSnackbar("Template deleted successfully", {
          variant: "success",
        });
        navigate("/w-template");
        refreshTemplates();
      })
      .catch((error) =>
        enqueueSnackbar(error?.message || "Could not delete template", {
          variant: "error",
        })
      );
    closeModalHandler();
  };

  return (
    <GModal
      heading="Delete template"
      visible={visible}
      closeModal={() => {
        closeModalHandler();
      }}
      bodyWrapperStyle={{ paddingRight: 0 }}
      bottomButtons={[
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Cancel"
          onClick={() => {
            closeModalHandler();
          }}
        />,
        <Button
          hierarchy="red"
          buttonText="Delete"
          onClick={deleteTemplateHandler}
        />,
      ]}
      body={
        <p className={classes.body}>
          Are you sure you want to delete <span>{name}</span> template?
        </p>
      }
    />
  );
};

export default DeleteTemplateModal;
